import queryStringBrowser from 'querystring-browser'
import httpRequest from './httpRequest'
import auth from './auth'

const loopbackUrl = '/loopback/api/'

export default {
  loopbackUrl: loopbackUrl,

  url (routeName, id, queryParams) {
    const queryString = '?' + queryStringBrowser.stringify(queryParams || {})

    const url = loopbackUrl +
      routeName +
      (id ? '/' + id : '') +
      queryString

    return url
  },

  fetch (routeName, id, queryParams) {
    const token = auth.getToken()
    const url = this.url(routeName, id, queryParams)
    return httpRequest.get(url, token)
  },

  put (routeName, id, data) {
    const token = auth.getToken()
    const url = this.url(routeName, id)
    return httpRequest.put(url, data, token)
  },

  patch (routeName, id, data) {
    const token = auth.getToken()
    const url = this.url(routeName, id)
    return httpRequest.patch(url, data, token)
  },

  post (routeName, id, data) {
    const token = auth.getToken()
    const url = this.url(routeName, id)
    return httpRequest.post(url, data, token)
  },

  delete (routeName, id, data) {
    const token = auth.getToken()
    const url = this.url(routeName, id)
    return httpRequest.delete(url, data, token)
  }
}
